import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InspirationState } from '../../models/inspiration.interface';

export const getInspirationsState = createFeatureSelector<InspirationState>('inspiration');

export const getAllInspirations = createSelector(getInspirationsState, (state) => state.allInspirations);

export const getFormatInspirations = (formatId: number) => {
  return createSelector(getInspirationsState, (state) => state.featuredFormatInspirations[formatId]);
};

export const getFeaturedInspirations = createSelector(getInspirationsState, (state) => state.featuredInspirations);

export const getViewedInspiration = createSelector(getInspirationsState, (state) => state.viewedInspiration);

export const getInspirationFormats = createSelector(getInspirationsState, (state) => state.inspirationFormats);

export const getPublication = createSelector(getInspirationsState, (state) => state.publication);

export const getArticle = createSelector(getInspirationsState, (state) => state.article);

export const getPreloginPublication = createSelector(getInspirationsState, (state) => state.publication);

export const getPreloginArticle = createSelector(getInspirationsState, (state) => state.article);
